// PhotoAPI.js
'use strict'

function csrfToken() {
    const el = document.querySelector('meta[name="csrf-token"]')
    return el ? el.getAttribute('content') : ''
}

async function handleJSON(res) {
    if (!res.ok) {
        const err = new Error(`HTTP ${res.status}`)
        err.status = res.status
        try {
            const ct = res.headers.get('Content-Type') || ''
            if (ct.includes('application/json')) err.body = await res.json()
        } catch {}
        throw err
    }
    if (res.status === 204) return null
    return res.json()
}

async function handleBlob(res) {
    if (!res.ok) {
        const err = new Error(`HTTP ${res.status}`)
        err.status = res.status
        throw err
    }
    return res.blob()
}

function getBlob(url, { signal, cache } = {}) {
    return fetch(url, {
        method: 'GET',
        headers: { Accept: 'image/*' },
        credentials: 'same-origin',
        signal,
        cache, // e.g. 'no-store'
    }).then(handleBlob)
}

function withBust(url, bust) {
    if (!bust) return url
    const u = new URL(url, window.location.origin)
    u.searchParams.set('_', String(Date.now()))
    return u.pathname + u.search
}

const paths = {
    photoUpdate: (photoId) => `/photos/${photoId}/update`,
    photoImage: (photoId) => `/photos/${photoId}/image`,
    photoPreview: (photoId) => `/photos/${photoId}/preview`,
    photoMask: (photoId) => `/photos/${photoId}/mask`,
}

const PhotoAPI = {
    updatePhoto(photo_id, { colorsample, mask, preview }) {
        const form = new FormData()
        form.append('colorsample', typeof colorsample === 'string' ? colorsample : JSON.stringify(colorsample || {}))
        form.append('mask', mask)
        form.append('preview', preview)

        return fetch(paths.photoUpdate(photo_id), {
            method: 'PUT',
            headers: { Accept: 'application/json', 'X-CSRF-TOKEN': csrfToken() },
            body: form,
            credentials: 'same-origin',
        }).then(handleJSON)
    },

    imageURL(id, { bust = false } = {}) {
        return withBust(paths.photoImage(id), bust)
    },
    previewURL(id, { bust = false } = {}) {
        return withBust(paths.photoPreview(id), bust)
    },
    maskURL(id, { bust = false } = {}) {
        return withBust(paths.photoMask(id), bust)
    },

    fetchImageBlob(id, opts) {
        return getBlob(paths.photoImage(id), opts)
    },
    fetchPreviewBlob(id, opts) {
        return getBlob(paths.photoPreview(id), opts)
    },
    fetchMaskBlob(id, opts) {
        return getBlob(paths.photoMask(id), opts)
    },
}

export default PhotoAPI
